var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{staticClass:"app-file-input__input",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.$emit('input', $event.target.files[0])}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }